import { useQuery } from '@tanstack/react-query';
import api from '@/services/auth.service';
import type { Visita } from '../types/visita.types';

// AIDEV-NOTE: Busca visita ativa (status=em_andamento) para exibir estado de check-in.
// Usa instancia axios (api) em vez de fetch nativo para respeitar VITE_API_URL em producao.

export function useVisitaAtiva() {
  return useQuery<Visita | null>({
    queryKey: ['visita-ativa'],
    queryFn: async () => {
      const res = await api.get<{ data: Visita[] }>('/visitas?status=em_andamento&limit=1');
      return res.data.data?.[0] ?? null;
    },
    refetchInterval: 30000 // Refetch a cada 30s
  });
}
